export const importantInfoLabels = {
  ipiLinkText: 'Important Plan Information',
  ibiLinkText: 'Important Broadband Information',
  ipiUrl: '/content/support/terms/products/important-plan-information/_jcr_content.raw.json',
  ibiUrl: '/support/broadband-services/',
};
